export class Success {
    constructor(value) {
        this.value = value;
    }
    map(fn) {
        return new Success(fn(this.value));
    }
    orElse() {
        return this;
    }
    chain(fn) {
        return fn(this.value);
    }
    match({ success }) {
        return success(this.value);
    }
    isSuccess() {
        return true;
    }
    isFail() {
        return false;
    }
    getOrElse() {
        return this.value;
    }
    getOrThrow() {
        return this.value;
    }
    get() {
        return this.value;
    }
}
;
export class Fail {
    constructor(error) {
        this.error = error;
    }
    map() {
        return this;
    }
    orElse(fn) {
        return new Fail(fn(this.error));
    }
    chain() {
        return this;
    }
    match({ fail }) {
        return fail(this.error);
    }
    isSuccess() {
        return false;
    }
    isFail() {
        return true;
    }
    getOrElse(value) {
        return value;
    }
    getOrThrow() {
        throw this.error;
    }
    err() {
        return this.error;
    }
}
;
export const fromNullable = (value, error = null) => ((value === null || value === undefined) ? Result.fail(error) : Result.success(value));
export const fromPromise = (promise) => promise.then(Result.success).catch((error) => Result.fail(error));
export const fromTry = (fn) => {
    try {
        return Result.success(fn());
    }
    catch (error) {
        return Result.fail(error);
    }
};
export const Result = {
    success: (value) => new Success(value),
    fail: (error) => new Fail(error),
    collectSuccess: (results) => results
        .filter((result) => result.isSuccess())
        .map((result) => result.get()),
    collectFail: (results) => results
        .filter((result) => result.isFail())
        .map((result) => result.err()),
    partition: (results) => {
        const partition = { success: [], fail: [] };
        for (const result of results) {
            if (result.isSuccess()) {
                partition.success.push(result.get());
            }
            else {
                partition.fail.push(result.err());
            }
        }
        return partition;
    },
};
